module.exports = __webpack_public_path__ + "img/Home.94fd837a.jpg";